export const MOCK_VULNERABILITIES_RESPONSE = {
  results: [
    {
      id: 'mock-vuln-1',
      cve: 'CVE-2024-12345',
      title: 'SQL Injection in Login Form',
      title_fa: 'تزریق SQL در فرم ورود',
      host: 'example.com',
      scan_seed: 'example.com',
      severity: 'critical',
      port: 443,
      timestamp: '2024-11-15T09:12:00Z',
      timestamp_jalali: '1403/08/25 09:12',
      description: 'The login endpoint is vulnerable to SQL injection via the username parameter.',
      description_fa: 'اندپوینت ورود از طریق پارامتر نام کاربری در برابر تزریق SQL آسیب‌پذیر است.',
      impact: 'Attackers could bypass authentication and access all user accounts.',
      comment: '',
    },
    {
      id: 'mock-vuln-2',
      cve: 'CVE-2024-54321',
      title: 'Cross-Site Scripting (Reflected)',
      title_fa: 'اسکریپت‌نویسی بین‌سایتی (بازتابی)',
      host: 'example.com',
      scan_seed: 'example.com',
      severity: 'high',
      port: 443,
      timestamp: '2024-11-15T09:15:00Z',
      timestamp_jalali: '1403/08/25 09:15',
      description: 'The search parameter reflects unsanitised user input into the HTML response.',
      description_fa: 'پارامتر جستجو ورودی کاربر را بدون پاکسازی در پاسخ HTML منعکس می‌کند.',
      impact: 'Can be used to steal session cookies or redirect users.',
      comment: '',
    },
    {
      id: 'mock-vuln-3',
      cve: null,
      title: 'Outdated TLS Version (TLS 1.0)',
      title_fa: 'نسخه قدیمی TLS (TLS 1.0)',
      host: 'api.example.com',
      scan_seed: 'example.com',
      severity: 'medium',
      port: 443,
      timestamp: '2024-11-15T09:20:00Z',
      timestamp_jalali: '1403/08/25 09:20',
      description: 'The server accepts TLS 1.0 connections which are considered insecure.',
      description_fa: 'سرور اتصالات TLS 1.0 را می‌پذیرد که ناامن تلقی می‌شوند.',
      impact: 'Traffic may be decrypted by a man-in-the-middle attacker.',
      comment: '',
    },
    {
      id: 'mock-vuln-4',
      cve: null,
      title: 'Missing X-Frame-Options Header',
      title_fa: 'هدر X-Frame-Options وجود ندارد',
      host: 'example.com',
      scan_seed: 'example.com',
      severity: 'low',
      port: 443,
      timestamp: '2024-11-15T09:25:00Z',
      timestamp_jalali: '1403/08/25 09:25',
      description: 'The application does not set the X-Frame-Options header, allowing clickjacking attacks.',
      description_fa: 'برنامه هدر X-Frame-Options را تنظیم نمی‌کند و حملات کلیک‌جکینگ را ممکن می‌سازد.',
      impact: 'Users may be tricked into clicking hidden elements.',
      comment: '',
    },
  ],
  current_page: 1,
  total_pages: 1,
}

export const MOCK_VULNERABILITY_FILTER_OPTIONS = {
  severity: ['critical', 'high', 'medium', 'low', 'info'],
  host: ['example.com', 'api.example.com'],
  status: ['open', 'closed'],
}
